// extracted by mini-css-extract-plugin
export default {"buttons":"BackNext_buttons__z4yX4","prev":"BackNext_prev__JVBju","hidden":"BackNext_hidden__+cHIq","next":"BackNext_next__Y6ypz","disabled":"BackNext_disabled__RWp84"};